/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PointX } from './pointX';
import type { PointValue } from './pointValue';
import type { Extras } from './extras';

export interface Point {
  x: PointX;
  value: PointValue;
  extras: Extras;
}
